// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 2076 ? "common" : chunkId) + ".0.64.0-dev.1777894314115.js";
};